import { dinTestActions, widgetActions } from '@/store';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
export function useReset() {
    var dispatch = useDispatch();
    return useCallback(function () {
        dispatch(dinTestActions.reset());
        dispatch(widgetActions.reset());
    }, [dispatch]);
}
